import { render, staticRenderFns } from "./DetailsStatusDropdown.vue?vue&type=template&id=a8c07904"
import script from "./DetailsStatusDropdown.vue?vue&type=script&lang=js"
export * from "./DetailsStatusDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports